import type { OilViscosityParameters } from "../../d";
import { deadOrLiveOilViscositiesCalculator } from "./deadOrLiveOilViscosityCalculator";

// Link to spreadsheet with new calculations:
// static/Dead.Oil.Andrade_w.Pressure
export function deadOilViscosityCalculator(params: OilViscosityParameters): {
  deadOilViscosity: number;
  a1: number;
  b1: number;
  a2: number;
  b2: number;
} {
  const { oilViscosity: deadOilViscosity, ...intermediates } =
    deadOrLiveOilViscositiesCalculator(params, "deadOilViscosityCP");
  return { deadOilViscosity, ...intermediates };
}
